module.exports = __webpack_public_path__ + "img/314.1db2bb30.jpg";